import { render } from "./brand.vue?vue&type=template&id=2fde6a54&scoped=true"
import script from "./brand.vue?vue&type=script&lang=js"
export * from "./brand.vue?vue&type=script&lang=js"

import "./brand.vue?vue&type=style&index=0&id=2fde6a54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fde6a54"]])

export default __exports__